jQuery( document ).ready(function() {
  if($('.faq').length > 0) {
    $('.faq_item').on('click', (e) => {
      $(e.currentTarget).find('.faq_response').toggle()
      $(e.currentTarget).find('.faq_openner').toggleClass('faq_openner-active')
    })
  }
});
